import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { FEATURE_FLAG_KEYS } from '../../features/OpenFeature'
import * as LegacyRoutes from './config_legacy'
import * as V2Routes from './config'

export const useRouteMapper = () => {
  const featureFlagValue = useBooleanFlagValue(
    FEATURE_FLAG_KEYS.enableDesignSystem2,
    false
  )

  const isDesignSystem2FlagEnabled =
    process.env.VITE_USE_V2_UI === 'true' ? featureFlagValue : false

  const routes = isDesignSystem2FlagEnabled ? V2Routes : LegacyRoutes

  return {
    ...routes.ROUTES_MAP,
    ALL_ROUTES: routes.ALL_ROUTES,
  }
}
